import gsap from 'gsap';
import Swiper from 'swiper/bundle';

// dropdown more employees
$(".employees:not(.-full) .open-more").on("click", function () {
    const thisBox = $(this).closest(".employees").find(".employee-container");
    const windowWidth = $(window).width();
    const boxHeight = calculateEmployeesBoxHeight(windowWidth);

    $(this).toggleClass("-open");
    thisBox.toggleClass("-open");

    if ($(this).hasClass("-open")) {
        expandEmployeesGallery(thisBox[0]);
    } else {
        closeEmployeesGallery(thisBox[0], boxHeight);
    }
});

function calculateEmployeesBoxHeight(windowWidth) {
    if (windowWidth < 1920 && windowWidth >= 1440) {
        return 1400;
    } else if (windowWidth < 1440 && windowWidth >= 1024) {
        return 1000;
    } else if (windowWidth < 1024 && windowWidth >= 768) {
        return 1000;
    }
    return 1600;
}

function expandEmployeesGallery(thisBox) {
    gsap.timeline()
        .to(thisBox, {
            duration: 1,
            delay: 0.1,
            height: "auto",
            ease: "power4.out"
        })
}

function closeEmployeesGallery(thisBox, height) {
    gsap.timeline()
        .to(thisBox, {
            delay: 0.1,
            duration: 1,
            ease: "power4.out",
            height: height,
        })
}


// slider mobile version employees
if($(".employees-slider.swiper-container").length > 0) {
    const employees_swiper = new Swiper(".employees-slider.swiper-container", {
        slidesPerView: 'auto',
        loop: false,
    });
}